export default "__VITE_ASSET__B1TpLjHV__"